import React from 'react';
import { Columns3, List } from 'lucide-react';
import Tooltip from '../ui/Tooltip';
import './BoardSummary.css';

const VIEWS = [
  { id: 'kanban', label: 'Kanban', aria: 'Kanban view', Icon: Columns3 },
  { id: 'list', label: 'List', aria: 'List view', Icon: List },
];

/** Segmented Kanban / List control (card 3.3). Icons only (owner,
 *  13.10.2026: keeps the toolbar on one row); the tooltip and aria-label name
 *  each segment, `aria-pressed` carries the state. */
export default function BoardViewToggle({ viewMode, onChange }) {
  return (
    <div className="task-board-segmented" role="group" aria-label="Board view">
      {VIEWS.map(({ id, label, aria, Icon }) => {
        const active = viewMode === id;
        return (
          <Tooltip key={id} content={label} side="bottom">
            <button
              type="button"
              aria-label={aria}
              aria-pressed={active}
              className={`task-board-segmented-btn task-board-segmented-btn--icon${active ? ' task-board-segmented-btn--active' : ''}`}
              onClick={() => {
                if (!active) onChange(id);
              }}
            >
              <Icon size={14} aria-hidden="true" />
            </button>
          </Tooltip>
        );
      })}
    </div>
  );
}
